import React from 'react'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../styles/theme.style'

export const Footnote = () => {
  const { t } = useTranslation()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 16px',
        flexShrink: 0,
        width: '100%',
        marginTop: 'auto',
        boxSizing: 'border-box'
      }}
    >
      <div style={{ color: 'white', fontSize: 10, opacity: 0.7, textAlign: 'center', lineHeight: 1.4 }}>
        © {new Date().getFullYear()} {theme.COMPANY_NAME}
      </div>
      <div style={{ color: 'white', fontSize: 10, opacity: 0.7, textAlign: 'center', marginTop: '2px', lineHeight: 1.4 }}>
        {t('All Rights Reserved')}
      </div>
    </div>
  )
}
